import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";
import "./Header.css";

const NAV_ITEMS = [
    { to: "/", label: "Główna" },
    { to: "/locations", label: "Lokalizacje" },
    { to: "/warehouses", label: "Magazyny" },
    { to: "/sold-products", label: "Sprzedane" },
    // { to: "/orders", label: "Zamówienia" },
    { to: "/add-product", label: "Dodaj produkt" },
];

const Header = ({ onLogout }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const close = () => setMenuOpen(false);

    return (
        <header className="header">
            <div className="container">
                <div className="logo">
                    <Link to="/" onClick={close}>
                        <span className="logo-badge">HSH</span>Group
                    </Link>
                </div>

                <button
                    className={`menu-button${menuOpen ? ' open' : ''}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Menu"
                >
                    <span className="hamburger">
                        <span className="hamburger-line" />
                        <span className="hamburger-line" />
                        <span className="hamburger-line" />
                    </span>
                </button>

                <nav>
                    <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
                        {NAV_ITEMS.map(({ to, label }) => (
                            <li key={to}>
                                <Link
                                    to={to}
                                    onClick={close}
                                    className={location.pathname === to ? "active" : ""}
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                        <li><span className="nav-divider" /></li>
                        <li>
                            <button className="logout-button" onClick={onLogout}>
                                <FaSignOutAlt size={12} />
                                Wyloguj
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
